import { arrayMove } from '@dnd-kit/sortable';

export const updateFavoriteOrdering = (
  favoriteIds: string[],
  activeId: string,
  overId: string,
): string[] => {
  if (activeId === overId) return favoriteIds;

  const activeIsFavorite = favoriteIds.includes(activeId);
  const overIsFavorite = favoriteIds.includes(overId);

  if (activeIsFavorite && overIsFavorite) {
    return arrayMove(
      favoriteIds,
      favoriteIds.indexOf(activeId),
      favoriteIds.indexOf(overId),
    );
  }

  if (!activeIsFavorite && overIsFavorite) {
    const next = [...favoriteIds];
    next.splice(favoriteIds.indexOf(overId), 0, activeId);
    return next;
  }

  if (activeIsFavorite && !overIsFavorite) {
    return favoriteIds.filter((id) => id !== activeId);
  }

  return favoriteIds;
};
